export default () => ({
  service: {},
  ticketQuickViewId: null
})
